import React from 'react';
import './progress-update.css';
import PropTypes from 'prop-types';

import { ProgressTeardrop } from './progress-teardrop';

const ProgressUpdate = props => {
    const {
        titlePosition,
        previousScores,
        updatedScores,
        ariaHideTeardrops,
    } = props;

    return (
        <div className="progress-update__teardrops">
            <ProgressTeardrop
                type="Media Profile"
                titlePosition={titlePosition}
                previousScore={previousScores.media}
                updatedScore={updatedScores.media}
                ariaHideTeardrop={ariaHideTeardrops}
            />
            <ProgressTeardrop
                type="Party Reputation"
                titlePosition={titlePosition}
                previousScore={previousScores.party}
                updatedScore={updatedScores.party}
                ariaHideTeardrop={ariaHideTeardrops}
            />
            <ProgressTeardrop
                type="Voter Support"
                titlePosition={titlePosition}
                previousScore={previousScores.voters}
                updatedScore={updatedScores.voters}
                ariaHideTeardrop={ariaHideTeardrops}
            />
        </div>
    );
};

ProgressUpdate.defaultProps = {
    titlePosition: 'bottom',
    previousScores: {
        party: 0,
        voters: 0,
        media: 0,
    },
    updatedScores: {
        party: 0,
        voters: 0,
        media: 0,
    },
};

ProgressUpdate.propTypes = {
    titlePosition: PropTypes.oneOf(['bottom', 'top']),
    previousScores: PropTypes.objectOf(PropTypes.number),
    updatedScores: PropTypes.objectOf(PropTypes.number),
};

export { ProgressUpdate };
